<template>
  <div id="sig-container" class="block full form-horizontal">
    <!-- Campo de búsqueda -->
    <h2><b>Filtros</b></h2>

    <div class="row">
      <div class="col-md-6 search-bar">
        <label for="search-input"><b>Buscar usuarios:</b></label>
        <input
          type="text"
          id="search-input"
          v-model="searchQuery"
          placeholder="Ingrese una busqueda"
          class="form-control"
        />
      </div>
    </div>

    <!-- Componente de tabla -->
    <table-component
      :data="filteredUsuarios"
      v-if="filteredUsuarios.length > 0"
      @click-event="clickEvent"
      pagination
    >
      <table-column
        slot="label"
        :label="'ID'"
        v-bind:value="'id'"
      ></table-column>
      <table-column
        slot="label"
        :label="'Vicidial'"
        v-bind:value="'vicidial_id'"
      ></table-column>
      <table-column
        slot="label"
        :label="'Tipo Documento'"
        v-bind:value="'tipo_documento'"
      ></table-column>
      <table-column
        slot="label"
        :label="'Documento'"
        v-bind:value="'identificacion'"
      ></table-column>
      <table-column
        slot="label"
        :label="'Nombre'"
        v-bind:value="'nombres'"
      ></table-column>
      <table-column
        slot="label"
        :label="'Apellidos'"
        v-bind:value="'apellidos'"
      ></table-column>
      <table-column
        slot="label"
        :label="'Usuario'"
        v-bind:value="'username'"
      ></table-column>

      <table-column slot="label" :label="'Acciones'" :icon="'fa'">
        <template
          slot="icon"
          :icon="'fa fa-edit'"
          :class="'btn btn-sm btn-primary'"
          :slug="'editar-usuario'"
          :tooltip="'Editar Usuario'"
        ></template>
        <!--template
          slot="icon"
          :icon="'fa fa-unlock-alt'"
          :class="'btn btn-sm btn-primary'"
          :slug="'permiso-usuario'"
          :tooltip="'Permisos Usuario'"
        ></template-->
      </table-column>
    </table-component>

    <!-- Mostrar mensaje cuando no haya usuarios -->
    <p style="text-align: center" v-else>
      No hay usuarios que coincidan con la búsqueda.
    </p>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "Usuarios",
  data() {
    return {
      searchQuery: "", // Campo de búsqueda
    };
  },
  computed: {
    ...mapGetters({ usuarios: "user/usuarios" }),

    // Computed property para filtrar los usuarios
    filteredUsuarios() {
      if (!this.searchQuery) {
        return this.usuarios;
      }

      const query = this.searchQuery.toLowerCase();

      return this.usuarios.filter((usuario) => {
        return Object.keys(usuario).some((key) => {
          const value = usuario[key];
          if (typeof value === "string") {
            return value.toLowerCase().includes(query);
          }
          if (typeof value === "number") {
            return value.toString().includes(query);
          }
          return false;
        });
      });
    },
  },
  components: {
    TableComponent: () => import("@@/components/table/TableComponent"),
    TableColumn: () => import("@@/components/table/TableColumn"),
  },
  methods: {
    clickEvent(data, slug) {
      switch (slug) {
        case "editar-usuario":
          this.$router.push({
            name: "editar-usuario",
            params: { id: data.id },
          });
          break;
        case "permiso-usuario":
          this.$router.push({
            name: "permiso-usuario",
            params: { id: data.id },
          });
          break;
      }
    },
  },
  mounted() {
    this.$store.dispatch("user/fetchUsuarios", {
      endpoint: "usuario",
      params: { paginar: false },
    });
  },
};
</script>

<style scoped>
.search-bar {
  margin-bottom: 15px;
}

.form-control {
  width: 100%;
  padding: 8px;
  box-sizing: border-box;
  font-size: 14px;
}

.search-bar {
  display: flex;
  align-items: center;
}

.search-bar label {
  margin-right: 5px;
}
</style>
